<template>
    <v-form v-model="valid" ref="form">
        <v-dialog v-model="dialog" width="800">
            <v-card class="no-padding">
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>End Session</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12">
                                You're about to end the Daily Extraction Session <span class="highlight">{{sessionIdentifier}}</span>. Would you like to continue?
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="6">
                                        <v-btn color="primary darken-1" @click="confirm()" :loading="loading" block>Yes</v-btn>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-btn color="warning" @click="dialog = false" block>No</v-btn>
                                    </v-col>
                                </v-row>
                                <v-spacer></v-spacer>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>

</template>

<script>

export default {
    data() {
        return {
            valid: false,
            dialog: false,
            sessionIdentifier: "",
            loading: false
        };
    },
    computed: {
        
    },
    methods: {
        showDialog(sessionIdentifier) {
            this.sessionIdentifier = sessionIdentifier;
            this.loading = false;

            this.dialog = true;
        },
        async confirm() {
            this.loading = true;
            this.$emit("confirmed");

            this.dialog = false;
        }
    }
}
</script>

<style scoped>

.highlight {
    font-weight: bold;
}

</style>